/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Intelligence_HeadlineInputs */



/**
* | output |
* | --- |
* | "Know what moved, and what to do about it." |
*
* @param {Products_Intelligence_HeadlineInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_intelligence_headline = /** @type {((inputs?: Products_Intelligence_HeadlineInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Intelligence_HeadlineInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Знайте, что изменилось и что с этим делать.")
	return /** @type {LocalizedString} */ ("Know what moved, and what to do about it.")
});